import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PoliticaCookies = () => {
  return (
    <div className="min-h-screen bg-[#020617] text-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-indigo-400 hover:text-indigo-300 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Política de Cookies</h1>
        
        <div className="prose prose-invert prose-slate max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. ¿Qué son las cookies?</h2>
            <p className="text-slate-300 leading-relaxed">
              Las cookies son pequeños archivos de texto que los sitios web almacenan en el dispositivo del usuario 
              (ordenador, tablet, smartphone) cuando los visita. Estos archivos permiten que el sitio web recuerde 
              información sobre su visita, como sus preferencias de idioma y otras opciones, lo que puede facilitar 
              su próxima visita y hacer que el sitio le resulte más útil.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Tipos de cookies utilizadas</h2>
            <p className="text-slate-300 leading-relaxed">
              Este sitio web puede utilizar los siguientes tipos de cookies:
            </p>
            
            <h3 className="text-xl font-semibold text-white mt-6 mb-3">Cookies técnicas o necesarias</h3>
            <p className="text-slate-300 leading-relaxed">
              Son aquellas que permiten al usuario la navegación a través de la página web y la utilización de las 
              diferentes opciones o servicios que en ella existen. Por ejemplo, controlar el tráfico y la comunicación 
              de datos, identificar la sesión, acceder a partes de acceso restringido, realizar el proceso de compra 
              de un pedido, utilizar elementos de seguridad durante la navegación o almacenar contenidos para la 
              difusión de vídeos o sonido.
            </p>
            <ul className="text-slate-300 space-y-2 mt-4 list-disc pl-6">
              <li><strong className="text-white">Cookie de consentimiento:</strong> Almacena la preferencia del usuario sobre el uso de cookies.</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-6 mb-3">Cookies de análisis o medición</h3>
            <p className="text-slate-300 leading-relaxed">
              Son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento 
              de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este 
              tipo de cookies se utiliza en la medición de la actividad de los sitios web con el fin de introducir 
              mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Gestión de cookies</h2>
            <p className="text-slate-300 leading-relaxed">
              Al acceder por primera vez a este sitio web, se mostrará un banner informativo sobre el uso de cookies, 
              donde el usuario podrá:
            </p>
            <ul className="text-slate-300 space-y-2 mt-4 list-disc pl-6">
              <li><strong className="text-white">Aceptar cookies:</strong> Se instalarán todas las cookies descritas en esta política.</li>
              <li><strong className="text-white">Rechazar cookies:</strong> Solo se instalarán las cookies técnicas necesarias para el funcionamiento básico del sitio.</li>
              <li><strong className="text-white">Configurar cookies:</strong> El usuario podrá seleccionar qué tipos de cookies desea aceptar.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Cómo eliminar las cookies</h2>
            <p className="text-slate-300 leading-relaxed">
              El usuario puede eliminar las cookies almacenadas en su dispositivo a través de la configuración 
              de su navegador. A continuación se proporcionan enlaces a las instrucciones de los navegadores más comunes:
            </p>
            <ul className="text-slate-300 space-y-2 mt-4 list-disc pl-6">
              <li>
                <a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300">
                  Google Chrome
                </a>
              </li>
              <li>
                <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300">
                  Mozilla Firefox
                </a>
              </li>
              <li>
                <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300">
                  Safari
                </a>
              </li>
              <li>
                <a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300">
                  Microsoft Edge
                </a>
              </li>
            </ul>
            <p className="text-slate-300 leading-relaxed mt-4">
              <strong className="text-white">Nota:</strong> Si el usuario decide bloquear o eliminar las cookies, 
              es posible que algunas funcionalidades del sitio web no funcionen correctamente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Actualización de la política</h2>
            <p className="text-slate-300 leading-relaxed">
              Esta Política de Cookies puede ser actualizada en cualquier momento para adaptarse a novedades 
              legislativas o cambios en el funcionamiento del sitio web. Se recomienda revisar esta política 
              periódicamente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Contacto</h2>
            <p className="text-slate-300 leading-relaxed">
              Para cualquier consulta relacionada con esta Política de Cookies, puede contactar con nosotros a través de:
            </p>
            <p className="text-indigo-400 mt-2">
              <a href="mailto:info@datyon.com" className="hover:text-indigo-300 transition-colors">info@datyon.com</a>
            </p>
          </section>

          <p className="text-slate-500 text-sm mt-12">
            Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PoliticaCookies;
